<template>
  <b-modal :id="modalId" modal-class="overflow-hidden" static scrollable @hidden="onHidden">
    <template #modal-header="{ close }">
      <h5>Chuyển trạng thái MC xác nhận</h5>
      <b-button size="sm" variant="light" @click="close()"> × </b-button>
    </template>

    <div>
      <div class="form-group">
        <label for="statusSelect">Chọn trạng thái:</label>
        <select
          id="statusSelect"
          v-model="selectedStatus"
          class="form-control"
          :class="{ 'is-invalid': showError && !selectedStatus }"
        >
          <option value="">-- Chọn trạng thái --</option>
          <option value="UNKNOWN">Không xác định</option>
          <option value="WAITING">Chờ MC xác nhận</option>
          <option value="CONFIRMED">MC đã xác nhận</option>
        </select>
        <div v-if="showError && !selectedStatus" class="invalid-feedback">
          Vui lòng chọn trạng thái
        </div>
      </div>
    </div>

    <template #modal-footer="{ cancel }">
      <b-button variant="light" @click="cancel()"> Hủy bỏ </b-button>
      <b-button variant="primary" @click="confirmChange" :disabled="!selectedStatus">
        Xác nhận
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: 'StatusChangeModal',
    props: {
      modalId: {
        type: String,
        default: 'statusChangeModal',
      },
      reqId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        selectedStatus: '',
        showError: false,
      }
    },
    methods: {
      confirmChange() {
        if (!this.selectedStatus) {
          this.showError = true
          return
        }

        this.$emit('confirm', {
          reqId: this.reqId,
          status: this.selectedStatus,
        })

        this.resetModal()
        this.$bvModal.hide(this.modalId)
      },

      onHidden() {
        this.resetModal()
      },

      resetModal() {
        this.selectedStatus = ''
        this.showError = false
      },
    },
  }
</script>

<style scoped>
  .form-group label {
    font-weight: 600;
    margin-bottom: 8px;
  }

  .form-control {
    border-radius: 4px;
    border: 1px solid #ced4da;
    padding: 0.375rem 0.75rem;
  }

  .form-control:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  .is-invalid {
    border-color: #dc3545;
  }

  .invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #dc3545;
  }
</style>
